module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "id",
      "id": "id"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group lp-flex-box",
    staticStyle: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("名称")]), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.biz.name),
      expression: "biz.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name"
    },
    domProps: {
      "value": (_vm.biz.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.biz, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "help-inline"
  }, [_vm._v("必填")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group lp-flex-box",
    staticStyle: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("权限")]), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.biz.permission),
      expression: "biz.permission"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text",
      "name": "permission",
      "id": "permission"
    },
    domProps: {
      "value": (_vm.biz.permission)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.biz, "permission", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "help-inline"
  }, [_vm._v("必填")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group lp-flex-box",
    staticStyle: {
      "align": "left"
    }
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8c55b3bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/PermissionEdit.vue
// module id = 314
// module chunks = 2 3